import QRious from 'qrious';

const qrious = async (token) => {
        let qrlink = await new QRious({
            value:`bankid:///?autostarttoken=${token}`,
            size: 100,
        }).toDataURL('image/jpeg');
        return qrlink
}

export {
    qrious
}